export const returnsBooleanValuesFromObject = (
  state: Record<string, any>,
  skeleton: Record<string, any>
) => {
  const result: Record<string, any> = {};

  for (const key in skeleton) {
    if (Array.isArray(skeleton[key])) {
      if (key in state && Array.isArray(state[key])) {
        result[key] = state[key].map((element: any) =>
          returnsBooleanValuesFromObject(element, skeleton[key][0])
        );
      } else {
        result[key] = [...skeleton[key]];
      }
    } else if (typeof skeleton[key] === "object") {
      result[key] = returnsBooleanValuesFromObject(
        state[key] || {},
        skeleton[key]
      );
    } else {
      result[key] = Boolean(state[key]);
    }
  }

  return result;
};
